module.exports = __webpack_public_path__ + "img/blue-tick.d3782e01.svg";